import { useQuery } from "@tanstack/react-query";
import { cautaTargetareFirma } from "@/api/endpoints/targetareConfig";
import { queryKeys } from "@/lib/queryClient";

export function useCautaTargetareFirma(q: string) {
  const text = q.trim();
  return useQuery({
    queryKey: queryKeys.targetare.cautaFirma(text),
    queryFn: () => cautaTargetareFirma(text),
    select: (response) => response.data,
    enabled: text.length >= 3,
    staleTime: 1000 * 60,
    retry: 0,
  });
}
